var App = App || {};

App.Login = (() => {
    const init = () => {
        const bsModal = new bootstrap.Modal(document.getElementById('login-modal'));
        const links = document.querySelectorAll('a[href="#login-modal"]');

        links.forEach((link) => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                bsModal.show();
            });
        });
    }

    return {
        init: init
    };
})();